module.exports = __webpack_public_path__ + "media/images/icons/user-a649335d00b062932d9f91d2c78549a3.svg";